import React from 'react'
import { Link } from 'react-router-dom'
import trastorno_panico from '../assets/images/psicologo/trastorno_panico.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${trastorno_panico})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Trastorno de pánico</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">Trastorno de pánico</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          El trastorno de pánico se caracteriza por ataques repentinos e intensos de miedo o malestar que alcanzan su máxima intensidad en minutos. Estos episodios pueden aparecer sin causa aparente y se acompañan de síntomas físicos intensos, generando temor constante a que vuelvan a ocurrir.
        </p>
        <br />
        <h4 className='text-warning'>¿Qué es el trastorno de pánico?</h4>
        <p className="text-muted">
          Implica una sobreactivación del sistema de alerta del cerebro, con participación de la amígdala y otras estructuras del sistema límbico. Desde la neuromodulación, se busca reducir la reactividad de estas áreas y aumentar el control que ejerce la corteza prefrontal sobre las respuestas de miedo.
        </p>
        <br />
        <h4>Síntomas comunes</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Físicos: palpitaciones, sudoración, dificultad para respirar, sensación de ahogo, mareos.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Cognitivos: miedo a morir, perder el control o “volverse loco”, pensamientos anticipatorios sobre nuevos ataques.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Conductuales: evitación de lugares o situaciones por temor a tener un ataque.
        </p>
        <br />
        
        <h4>Neuromodulación</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Magnética Transcraneal (EMT): estimulación en áreas prefrontales para mejorar la regulación emocional.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Transcraneal por Corriente Directa (tDCS): modulación de redes relacionadas con la percepción del miedo.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Neurofeedback: entrenamiento para reducir la hiperactivación fisiológica.
        </p>
      </div>
    </div>
  </div>
</section>
    <Footer/>
    </>
  )
}
